import React from 'react';
import nakshi from '../../../images/nakshi.png';
import zazabor from '../../../images/zazabor.png';
import gurukul from '../../../images/gurukul.png';
import { Link } from 'react-router-dom';
const Projects = () => {
    return (
        <div id="projects" className="w-full px-4 mb-8 py-4 lg:py-16 text-white flex flex-col items-center justify-evenly">
            <h2 className="text-white text-4xl font-caveat my-4 lg:my-8 col-span-1 lg:col-span-3">My Projects</h2>
            <div className="w-full grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="mx-auto container border-gray-500 border-2 hover:border-red-700">
                    <img src={nakshi} />
                    <h3 className="font-concertone text-lg">Nakshi - Handi Craft Shop Website</h3>
                    <ul className="font-titillium text-sm">
                        <li>Web Stack: React, Express, Node, MongoDB</li>
                        <li>Other: Firebase,tailwind css, github</li>
                    </ul>
                    <Link to="project-1">
                        <button className="font-poppins text-sm my-4 px-2 py-1 border-2 border-red-700
                hover:bg-red-700
                ">Details</button>
                    </Link>
                </div>
                <div className="mx-auto container border-gray-500 border-2 hover:border-red-700">
                    <img src={zazabor} />
                    <h3 className="font-concertone text-lg">ZAZABOR Travels - Travel Agency Website</h3>
                    <ul className="font-titillium text-sm">
                        <li>Web Stack: React, Express, Node, MongoDB</li>
                        <li>Other: Firebase,tailwind css, github</li>
                    </ul>
                    <Link to="project-2">
                        <button className="font-poppins text-sm my-4 px-2 py-1 border-2 border-red-700
                hover:bg-red-700
                ">Details</button>
                    </Link>
                </div>
                <div className="mx-auto container border-gray-500 border-2 hover:border-red-700">
                    <img src={gurukul} />
                    <h3 className="font-concertone text-lg">Gurukul - Education Academy Website</h3>
                    <ul className="font-titillium text-sm">
                        <li>Web Stack: React, Express, Node, MongoDB</li>
                        <li>Other: Firebase,tailwind css, github</li>
                    </ul>
                    <Link to="project-3">
                        <button className="font-poppins text-sm my-4 px-2 py-1 border-2 border-red-700
                hover:bg-red-700
                ">Details</button>
                    </Link>
                </div>

            </div>
            <a target="_blank" href="https://github.com/shudiptod?tab=repositories"
                className="w-6/12 lg:w-3/12 mx-auto cursor-pointer border-2 border-red-700 bg-transparent mt-8 px-4 py-4 font-serif hover:bg-red-700 text-white">
                View All on Github
            </a>
        </div>
    );
};

export default Projects;